/**
 * @generated SignedSource<<eed9111163884a8990d4a18507543a4a>>
 * @relayHash 4f4bf514c6fc4ce65199ab30730b54fa
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d0f808bd54eb268234c12a74e7a54c56f3997838cd6a9b781b1eeb9a93d44044

import { ConcreteRequest, Query } from 'relay-runtime';
export type useAuthRedirectQuery$variables = Record<PropertyKey, never>;
export type useAuthRedirectQuery$data = {
  readonly viewer: {
    readonly id: string;
  } | null | undefined;
};
export type useAuthRedirectQuery = {
  response: useAuthRedirectQuery$data;
  variables: useAuthRedirectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthRedirectQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAuthRedirectQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "d0f808bd54eb268234c12a74e7a54c56f3997838cd6a9b781b1eeb9a93d44044",
    "metadata": {},
    "name": "useAuthRedirectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2c8173ad5b3306e1a968e3388f606e33";

export default node;
